import { useEffect, useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useLocation } from 'react-router-dom'
import { cancelRegistration } from '../services/registrationService'

export default function useCancelRegistration() {
    const [message, setMessage] = useState(null)
    const location = useLocation()
    const urlSearchParams = new URLSearchParams(location.search)
    const token = urlSearchParams.get('token')

    const mutation = useMutation({
        mutationFn: () => cancelRegistration({ token }),
        onSuccess: (res) => {
            setMessage({
                type: 'Go Around!',
                text: res.message,
                navigateTo: '/',
                replace: false,
            })
        },
        onError: (error) => {
            setMessage({
                type: 'Cancel Error',
                text: `An error occurred while trying to cancel the registration process: ${error}`,
            })
        },
    })

    // Trigger mutation on mount
    useEffect(() => {
        if (token) mutation.mutate()
    }, [token, mutation])

    return { message, setMessage }
}
